const slick = require('slick-carousel');
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Toggler from "../../../../scripts/classes/Toggler";
import Equalizer from '../../../../scripts/classes/Equalizer';

var KeyContactsSlider = function (options) {

    this.options = {
        $el: false
    };

    $.extend(true, this.options, options);

}

KeyContactsSlider.prototype.init = function () {

    let self = this;

    self.$keyContactsSlider = self.options.$el.find('.c-slider');

    self.toggler = new Toggler( self.options.$el );
    self.toggler.init();
    self.toggler.trigger.on('click', function() {
        self.toggler.target.toggleClass('hide');
        if(self.toggler.target.hasClass('hide')) {
            $('html, body').animate({
                scrollTop: self.options.$el.offset().top
            }, 300, 'linear');
        }
    });

    var equalizer = new Equalizer(self.$keyContactsSlider.find('.c-card__body'));
    equalizer.equalizeHeights();


    self.$keyContactsSlider.slick({
        // speed: 350,
        slidesToShow: 3,
        infinite: true,
        arrows: false,
        // dots: false,
        // fade: true,
        autoplay: true,
        autoplaySpeed: 4000,

        responsive: [
            // {
            //   breakpoint: 1024,
            //   settings: {
            // 	slidesToShow: 3,
            // 	slidesToScroll: 3,
            // 	infinite: true,
            // 	dots: true
            //   }
            // },
            {
              breakpoint: 800,
              settings: {
                slidesToShow: 1,
                rows: 16,
              }
            }
        ]
    });


    self.options.$el.find(`[data-slider-nav] .c-slider__dot`).on('click', function() {
            
        self.options.$el.find(`[data-slider-nav] .c-slider__dot`).removeClass('active');
        $(this).addClass('active');

        var slideNumber = $(this).data('slideNumber');

        self.$keyContactsSlider.slick('slickGoTo', slideNumber - 1);

    });

    this.$keyContactsSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {

		self.options.$el.find(`[data-slider-nav] .c-slider__dot`).removeClass('active');
		self.options.$el.find(`[data-slide-number="${nextSlide+1}"]`).addClass('active');

	});
    
};

export default KeyContactsSlider;